export default "__VITE_ASSET__CaA7LrV4__"